export default "__VITE_ASSET__B8VPsZkP__"